<template>
  <UpdateTaskCustomField />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import UpdateTaskCustomField from "../../components/TaskCustomFields/UpdateTaskCustomField.vue";

export default defineComponent({
  name: "UpdateTaskCustomFieldPage",
  components: {
    UpdateTaskCustomField,
  },
});
</script>